import config from "../../config";
const baseUrl = config.baseUrl;

export const LabDiagnosisUrls = {

 LAB_DIAGNOSIS_ADD: baseUrl + "/labDiagnosis",
 LAB_DIAGNOSIS_EDIT: baseUrl + "/labDiagnosis",
 LAB_DIAGNOSIS_STATUS: baseUrl + "/labDiagnosis/changedStatus",
 LAB_DIAGNOSIS_LIST: baseUrl + "/labDiagnosis",
 LAB_DIAGNOSIS_DELETE: baseUrl + "/labDiagnosis",
 LAB_DIAGNOSIS_GETBYID: baseUrl + "/labDiagnosis",
 LAB_DIAGNOSIS_ROLLBACK: baseUrl + "/labDiagnosis/rollback",
 LAB_DIAGNOSIS_DROPDOWN: baseUrl + "/labDiagnosis/dropdown?export=true", 
 LAB_DIAGNOSIS_DELETE_HARD: baseUrl + "/labDiagnosis",
}